import { GripVertical } from 'lucide-react'

interface DraggableElementProps {
  x?: number
  y: number
  width?: string | number
  dragging: boolean
  onMouseDown: (e: React.MouseEvent) => void
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  /** Número do bloco (espelha Controles de Layout) */
  blockNumber?: number
}

export function DraggableElement({
  x,
  y,
  width,
  dragging,
  onMouseDown,
  children,
  className = '',
  style = {},
  blockNumber,
}: DraggableElementProps) {
  const leftStyle = x !== undefined ? `${x}%` : '8%'
  const widthStyle = width !== undefined ? (typeof width === 'number' ? `${width}%` : width) : (x !== undefined ? 'auto' : '84%')

  return (
    <div
      className={`absolute cursor-grab active:cursor-grabbing group hover:bg-white/5 hover:outline hover:outline-dashed hover:outline-emerald-500/20 rounded p-1 transition-all duration-150 ${dragging ? 'bg-emerald-500/10 outline outline-emerald-500 z-10' : ''} ${className}`}
      style={{
        left: leftStyle,
        top: `${y}%`,
        width: widthStyle,
        ...style
      }}
      onMouseDown={onMouseDown}
    >
      {blockNumber !== undefined && (
        <span
          className="absolute -top-1 -left-1 z-20 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#ff2f86] px-0.5 text-[9px] font-black text-white opacity-0 shadow-md transition-opacity group-hover:opacity-100 pointer-events-none"
          title={`Bloco ${blockNumber}`}
        >
          {blockNumber}
        </span>
      )}
      <div className="flex items-start gap-1 w-full min-w-0">
        <GripVertical
          size={10}
          className="shrink-0 mt-1 opacity-0 group-hover:opacity-60 transition-opacity text-emerald-400"
        />
        <div className="min-w-0 flex-1 select-none leading-tight">{children}</div>
      </div>
      {dragging && (
        <div className="absolute inset-0 border border-dashed border-emerald-400 rounded pointer-events-none" />
      )}
    </div>
  )
}
